import angular from 'angular'
import coverPage from './view/invoice.html'

const contractInvoice = angular.module('app.input.electronImage.contractInvoice', [])

export default contractInvoice.name

class ContractInvoiceCtrl {
    constructor(httpRequest, $state, sweetalert, logger, formvalidateApi, $scope, $http) {
        // {currentObj, list, total, currentPage}
        this.pageInfo = {
            list: [],
        }
        this.errorFields = {}
        function generatePageInfo(list, pageNum) {
            const currentPage = pageNum < 1 ? 1 : pageNum
            list.forEach((item) => {
                const { storageKey } = item
                if (storageKey) {
                    const fileSurfix = storageKey.substring(storageKey.lastIndexOf('.'))
                    item.isPDF = fileSurfix.toLowerCase() === '.pdf'
                }
            })
            return {
                list,
                currentObj: list[currentPage - 1],
                total: list.length,
                currentPage,
            }
        }
        this.$onChanges = function onChanges() {
            if (this.contractInfo) {
                this.pageInfo = generatePageInfo(this.contractInfo.contractInvoiceList, this.pageInfo.currentPage - 1)
                this.onPage(this.pageInfo.currentObj)
            }
        }
        this.deleteInvoice = function deleteInvoice() {
            sweetalert.confirm('删除提醒', '是否删除该发票？').then(() => {
                httpRequest.get_deleteInvoice({
                    params: {
                        invoiceId: this.pageInfo.currentObj.invoiceId,
                        contractId: this.contractInfo.contractId,
                    },
                }).then(() => {
                    this.contractInfo.contractInvoiceList.splice(this.pageInfo.currentPage - 1, 1)
                    this.pageInfo = generatePageInfo(this.contractInfo.contractInvoiceList, this.pageInfo.currentPage - 1)
                    logger.logSuccess('删除成功')
                    $scope.$emit('contractStatisticChange')
                })
            })
        }
        this.saveInvoice = function saveInvoice() {
            const ret = formvalidateApi.run()
            if (!ret) {
                return
            }
            this.pageInfo.currentObj.contractId = this.contractInfo.contractId
            httpRequest.post_updateInvoice(this.pageInfo.currentObj).then(() => {
                logger.logSuccess('保存成功')
                // 修改发票种类触发统计信息修改
                $scope.$emit('contractStatisticChange')
                this.onPage(this.pageInfo.currentObj)
            })
        }
        this.cancel = function cancel() {
            if ($state.current.name === 'input.electronImage.contractEntering.edit') {
                $state.go('input.electronImage.contractEntering.list')
            } else {
                $state.go('^')
            }
        }
        this.onPage = function onPage(invoice) {
            if (invoice && invoice.verifyStatus === '1' && invoice.archiveStatus !== '1') {
                $http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/invoiceProofread`, invoice).then((res) => {
                    if (res.data.value.length > 0) {
                        res.data.value.errorList.forEach((item) => {
                            Object.keys(invoice).forEach((key) => {
                                if (item === key) {
                                    this.errorFields[key] = true
                                }
                            })
                        })
                    }
                })
            }
        }
    }
}

ContractInvoiceCtrl.$inject = ['httpRequest', '$state', 'sweetalert', 'logger', 'formvalidateApi', '$scope', '$http']
contractInvoice.controller('contractInvoiceCtrl', ContractInvoiceCtrl)
contractInvoice.component('contractInvoice', {
    template: coverPage,
    bindings: {
        contractInfo: '<',
        readonly: '<',
    },
    controller: 'contractInvoiceCtrl',
})



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/contractInvoice.js